module.exports = __webpack_public_path__ + "components/wind-icon/static/WSW@2x-99aa4fb59cea19521ca568fa9204f284.png";